import {
	Root as RadixSwitchRoot,
	Thumb as RadixSwitchThumb
} from '@radix-ui/react-switch'
import type { FC } from 'react'
import { useId } from 'react'
import { cn } from '@/helpers/utils'

interface SwitchProps {
	className?: string
	label?: string
	labelPosition?: 'left' | 'right'
	disabled?: boolean
	checked?: boolean
	onChange?: (checked: boolean) => void
}

export const Switch: FC<SwitchProps> = ({
	label,
	className,
	labelPosition = 'right',
	disabled,
	checked = false,
	onChange
}) => {
	const id = useId()

	return (
		<div
			className={cn(
				'flex items-center gap-2 whitespace-nowrap [&_label]:font-semibold [&_label]:text-sm',
				labelPosition === 'left' && 'flex-row-reverse',
				className
			)}
		>
			<RadixSwitchRoot
				checked={checked}
				className='relative h-6 w-11 cursor-pointer rounded-[48px] bg-neutral-300 transition-colors duration-100 will-change-[background-color] data-[state=checked]:bg-primary-600'
				disabled={disabled}
				id={id}
				onCheckedChange={(value) => onChange?.(value)}
			>
				<RadixSwitchThumb className='block h-5 w-5 translate-x-0.5 rounded-full bg-neutral-white shadow-[0_1px_3px_0_rgba(16,24,40,0.1)] transition-transform duration-100 will-change-transform data-[state=checked]:translate-x-[22px]' />
			</RadixSwitchRoot>
			{label && <label htmlFor={id}>{label}</label>}
		</div>
	)
}

Switch.displayName = 'Switch'
